export default "__VITE_ASSET__C1zrQskq__"